import React, { useState, useEffect } from 'react';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [users, setUsers] = useState([]);
  const [loginError, setLoginError] = useState('');
  const [signupSuccess, setSignupSuccess] = useState(false);

  const handleToggle = () => {
    setIsLogin(!isLogin);
    setName('');
    setEmail('');
    setPassword('');
    setLoginError('');
    setSignupSuccess(false);
  };

  const handleLogin = () => {
    const loggedInUser = users.find(
      (user) => user.email === email && user.password === password
    );

    if (loggedInUser) {
      localStorage.setItem('loggedInUser', JSON.stringify(loggedInUser));
      onLogin(loggedInUser);
      setLoginError('');
    } else {
      setLoginError('Invalid email or password or you must have signup for login');
    }
  };

  const handleSignup = () => {
    if (!email.includes('@')) {
      setLoginError('Please enter a valid email address');
      return;
    }

    if (password.length < 6) {
      setLoginError('Password must be at least 6 characters long');
      return;
    }

    const newUser = { name, email, password };
    setUsers([...users, newUser]);
    setName('');
    setEmail('');
    setPassword('');
    setIsLogin(true);
    setLoginError('');
    setSignupSuccess(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('loggedInUser');
    onLogin(null);
    setIsLogin(true);
  };

  const loggedInUser = localStorage.getItem('loggedInUser');

  useEffect(() => {
    let timer;
    if (signupSuccess) {
      timer = setTimeout(() => {
        setSignupSuccess(false);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [signupSuccess]);

  return (
    <div className="login-page">
      {loggedInUser ? (
        <>
          <h1>Welcome, {JSON.parse(loggedInUser).name}!</h1>
          <button onClick={handleLogout}>Logout</button>
        </>
      ) : (
        <>
          <h1>{isLogin ? 'Login' : 'Sign Up'}</h1>
          {!isLogin && (
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {loginError && <p className="error-message">{loginError}</p>}
          {signupSuccess && (
            <p className="success-message blink">Sign up successful! You can now login.</p>
          )}
          <button onClick={isLogin ? handleLogin : handleSignup}>
            {isLogin ? 'Login' : 'Sign Up'}
          </button>
          <button className="signUp-button" onClick={handleToggle}>
            {isLogin ? 'Sign Up' : 'Login'}
          </button>
        </>
      )}
    </div>
  );
};

export default LoginPage;
